import { Link } from 'react-router-dom'
import './Navigation.css'

function Navigation({ isOpen, onClose }) {
  return (
    <nav className={`navigation ${isOpen ? 'open' : ''}`}>
      <ul className="nav-list">
        <li>
          <Link to="/" onClick={onClose}>Home</Link>
        </li>
        <li>
          <Link to="/about" onClick={onClose}>About</Link>
        </li>
          <li>
            <Link to="/author" onClick={onClose}>Author/Founder</Link>
          </li>
        <li>
          <a href="https://zeropanik.com/" onClick={onClose} target="_blank" rel="noopener noreferrer">Causes</a>
        </li>
        <li>
          <a href="https://zeropanik.shop/" onClick={onClose} target="_blank" rel="noopener noreferrer">Shop</a>
        </li>
        <li>
          <a href="http://cristinatrujillo.me/" onClick={onClose} target="_blank" rel="noopener noreferrer">About Me</a>
        </li>
        <li>
          <a href="https://cristinatrujillo.org/" onClick={onClose} target="_blank" rel="noopener noreferrer">Services</a>
        </li>
      </ul>
    </nav>
  )
}

export default Navigation
